import useMediaQuery from "@mui/material/useMediaQuery";
const usePrefersReducedMotion = () => useMediaQuery("(prefers-reduced-motion: reduce)", { noSsr: true });
export default usePrefersReducedMotion;
//# sourceMappingURL=usePrefersReducedMotion.js.map